"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Tooltip = ({
  type,
  className,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTooltip, {
  type: "light",
  effect: "solid",
  wrapper: "span",
  html: true,
  isCapture: true,
  className: `rui-tooltip rui-tooltip--${type} ${className ? className : ''}`.trim(),
  ...props
});

Tooltip.propTypes = {
  type: _propTypes.default.oneOf(['standard', 'inverted']),
  delayHide: _propTypes.default.number,
  delayShow: _propTypes.default.number,
  place: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  className: _propTypes.default.string
};
Tooltip.defaultProps = {
  type: 'standard',
  delayHide: 250,
  delayShow: 250,
  className: undefined,
  place: 'top'
};
var _default = Tooltip;
exports.default = _default;